import Vue from "vue";
import VueRouter from "vue-router";
// import App from './components/App';
import DataTable from './components/DataTable';
import Login from './components/Login';
import Register from './components/Register';

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: "/",
            component: DataTable
        },
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/register",
            component: Register,
            name: "register",
        }
    ],
    mode: "history"
});